'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["open", "options", "placement", "tooltip", "value", "disabled"];
import Controllable from 'UIComponents/decorators/Controllable';
import { DropdownCaret } from 'foundations-components/transitional/components/AbstractDropdown';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { TextToolbarIcon } from './TextToolbarIcon';
import UIAbstractIconDropdown from './abstract/UIAbstractIconDropdown';
import SimpleStyledClickable from './internal/SimpleStyledClickable';
import { jsx as _jsx } from "react/jsx-runtime";
class UITextToolbarIconDropdownCore extends Component {
  render() {
    const _this$props = this.props,
      {
        open,
        options,
        placement,
        tooltip,
        value: currentValue,
        disabled
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const selectedOption = options.find(({
      value
    }) => value === currentValue);
    const renderedIcon = selectedOption ? /*#__PURE__*/_jsx(TextToolbarIcon, {
      disabled: disabled,
      icon: selectedOption.Icon,
      blockSize: "24px"
    }) : null;
    return /*#__PURE__*/_jsx(Tooltip, {
      open: open ? false : undefined,
      placement: placement,
      title: tooltip,
      disabled: disabled,
      children: /*#__PURE__*/_jsx(UIAbstractIconDropdown, Object.assign({
        Button: SimpleStyledClickable,
        buttonText: renderedIcon,
        caretRenderer: /*#__PURE__*/_jsx(DropdownCaret, {
          buttonUse: "transparent"
        }),
        open: open,
        options: options,
        value: currentValue,
        disabled: disabled
      }, rest))
    });
  }
}
UITextToolbarIconDropdownCore.displayName = 'UITextToolbarIconDropdownCore';
UITextToolbarIconDropdownCore.defaultProps = {
  open: false,
  placement: 'bottom'
};
UITextToolbarIconDropdownCore.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func,
  onOpenChange: PropTypes.func,
  open: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    Icon: PropTypes.any
  }).isRequired).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  disabled: PropTypes.bool
};
const UITextToolbarIconDropdown = Controllable(UITextToolbarIconDropdownCore, ['open', 'value']);
UITextToolbarIconDropdown.displayName = 'UITextToolbarIconDropdown';
export default UITextToolbarIconDropdown;